<div class="modal-main">
  <div
    class="header d-flex justify-content-center align-items-center position-relative pt-3 pb-3 px-4"
  >
    <h1 class="modal-title mb-0">{{ "DELETE_ACCOUNT" | translate }}</h1>
    <img
      src="/assets/svg/ico-hamburger-close.svg"
      class="cross-button position-absolute pointer-cursor"
      (click)="closeDialog()"
    />
  </div>

  <div class="content px-4 pt-5">
    <h2 class="verify-title text-center">{{ "VERIFY_ACCOUNT" | translate }}</h2>

    <div class="row justify-content-center mt-3">
      <p class="text-center verify-description">
        <ng-container *ngIf="medium === 'phone'; else emailText">
          {{ "ENTER_VERIFICATION_CODE_SENT_TO_PHONE" | translate }}
          <strong class="font-weight-bold">{{ phoneLastDigits }}</strong>
        </ng-container>
        <ng-template #emailText>
          {{ "ENTER_VERIFICATION_CODE_SENT_TO_EMAIL" | translate }}
          <strong class="font-weight-bold"></strong>
        </ng-template>
      </p>
    </div>

    <div class="row justify-content-center mt-4">
      <ngx-otp-input
        [config]="otpInputConfig"
        (fill)="handleFillEvent($event)"
        (focusout)="validateOtp()"
        #ngxotp
      >
      </ngx-otp-input>
    </div>
    <!-- Top link: sends code to current medium -->
    <p class="pt-2 text-center resend-text">
      {{ "DID_NOT_RECIEVE_ACODE" | translate }}
      <a
        href="javascript:void(0);"
        class="verification-link pointer-cursor"
        (click)="resendCode()"
      >
        {{ "RESEND_CODE" | translate }}
      </a>
    </p>
    <!-- Bottom link: toggles medium and resends -->
    <p class="text-center resend-text">
      <a
        href="javascript:void(0);"
        class="verification-link pointer-cursor"
        (click)="toggleAndResend()"
      >
        {{ "RESEND_CODE" | translate }}
      </a>
      {{ (medium === "phone" ? "TO_MY_EMAIL" : "TO_MY_PHONE") | translate }}
    </p>
  </div>
</div>
